import {
  FETCH_SMM_POST_CHANNEL_STATUS_LIST,
  FETCH_SMM_POST_CHANNEL_STATUS_DATA,
  CREATE_SMM_POST_CHANNEL_STATUS,
  UPDATE_SMM_POST_CHANNEL_STATUS,
  DELETE_SMM_POST_CHANNEL_STATUS,
  FETCH_SMM_POST_LIST,
  FETCH_SMM_POST_DATA,
  CREATE_SMM_POST,
  UPDATE_SMM_POST,
  DELETE_SMM_POST,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST,
  FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA,
  CREATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER,
  DELETE_MASTER_SOCIAL_MEDIA_PROVIDER,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST,
  FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA,
  CREATE_MASTER_SOCIAL_MEDIA_PROFILE,
  UPDATE_MASTER_SOCIAL_MEDIA_PROFILE,
  DELETE_MASTER_SOCIAL_MEDIA_PROFILE,
  GENERATE_SMM_POST_CONTENT,
  GENERATE_SMM_POST_IMAGE,
  SOCIAL_MEDIA_CONNECT_START,
  SOCIAL_MEDIA_CONNECT_COMPLETE,
  SOCIAL_MEDIA_CONNECT_ASSIGN,
  SOCIAL_MEDIA_CONNECT_DISCONNECT,
} from "./actionType";

import {
  fetchSmmPostChannelStatusListSuccess,
  fetchSmmPostChannelStatusListFailure,
  fetchSmmPostChannelStatusDataSuccess,
  fetchSmmPostChannelStatusDataFailure,
  createSmmPostChannelStatusSuccess,
  createSmmPostChannelStatusFailure,
  updateSmmPostChannelStatusSuccess,
  updateSmmPostChannelStatusFailure,
  deleteSmmPostChannelStatusSuccess,
  deleteSmmPostChannelStatusFailure,
  fetchSmmPostListSuccess,
  fetchSmmPostListFailure,
  fetchSmmPostDataSuccess,
  fetchSmmPostDataFailure,
  createSmmPostSuccess,
  createSmmPostFailure,
  updateSmmPostSuccess,
  updateSmmPostFailure,
  deleteSmmPostSuccess,
  deleteSmmPostFailure,
  fetchMasterSocialMediaProviderListSuccess,
  fetchMasterSocialMediaProviderListFailure,
  fetchMasterSocialMediaProviderDataSuccess,
  fetchMasterSocialMediaProviderDataFailure,
  createMasterSocialMediaProviderSuccess,
  createMasterSocialMediaProviderFailure,
  updateMasterSocialMediaProviderSuccess,
  updateMasterSocialMediaProviderFailure,
  deleteMasterSocialMediaProviderSuccess,
  deleteMasterSocialMediaProviderFailure,
  fetchMasterSocialMediaProfileListSuccess,
  fetchMasterSocialMediaProfileListFailure,
  fetchMasterSocialMediaProfileDataSuccess,
  fetchMasterSocialMediaProfileDataFailure,
  createMasterSocialMediaProfileSuccess,
  createMasterSocialMediaProfileFailure,
  updateMasterSocialMediaProfileSuccess,
  updateMasterSocialMediaProfileFailure,
  deleteMasterSocialMediaProfileSuccess,
  deleteMasterSocialMediaProfileFailure,
  generateSmmPostContentSuccess,
  generateSmmPostContentFailure,
  generateSmmPostImageSuccess,
  generateSmmPostImageFailure,
  socialMediaConnectStartSuccess,
  socialMediaConnectStartFailure,
  socialMediaConnectCompleteSuccess,
  socialMediaConnectCompleteFailure,
  socialMediaConnectAssignSuccess,
  socialMediaConnectAssignFailure,
  socialMediaConnectDisconnectSuccess,
  socialMediaConnectDisconnectFailure,
} from "./action";

import {
  fetchSmmPostChannelStatusListApi,
  fetchSmmPostChannelStatusDataApi,
  createSmmPostChannelStatusApi,
  updateSmmPostChannelStatusApi,
  deleteSmmPostChannelStatusApi,
  fetchSmmPostListApi,
  fetchSmmPostDataApi,
  createSmmPostApi,
  updateSmmPostApi,
  deleteSmmPostApi,
  getListMasterSocialMediaProviderApi,
  getDataMasterSocialMediaProviderApi,
  createMasterSocialMediaProviderApi,
  updateMasterSocialMediaProviderApi,
  deleteMasterSocialMediaProviderApi,
  getListMasterSocialMediaProfileApi,
  getDataMasterSocialMediaProfileApi,
  createMasterSocialMediaProfileApi,
  updateMasterSocialMediaProfileApi,
  deleteMasterSocialMediaProfileApi,
  generateSmmPostContentApi,
  generateSmmPostImageApi,
  socialMediaConnectStartApi,
  socialMediaConnectCompleteApi,
  socialMediaConnectAssignApi,
  socialMediaConnectDisconnectApi,
} from "../../helpers/fakebackend_helper";

import { call, put, takeEvery, all } from "redux-saga/effects";
//FETCH_SMM_POST_CHANNEL_STATUS_LIST
function* fetchSmmPostChannelStatusListSaga() {
  try {
    const response = yield call(fetchSmmPostChannelStatusListApi);
    yield put(fetchSmmPostChannelStatusListSuccess(response));
  } catch (error) {
    yield put(fetchSmmPostChannelStatusListFailure(error.message));
  }
}
//FETCH_SMM_POST_CHANNEL_STATUS_DATA
function* fetchSmmPostChannelStatusDataSaga(action) {
  try {
    const response = yield call(
      fetchSmmPostChannelStatusDataApi,
      action.payload
    );
    yield put(fetchSmmPostChannelStatusDataSuccess(response));
  } catch (error) {
    yield put(fetchSmmPostChannelStatusDataFailure(error.message));
  }
}
//CREATE_SMM_POST_CHANNEL_STATUS
function* createSmmPostChannelStatusSaga(action) {
  try {
    const response = yield call(createSmmPostChannelStatusApi, action.payload);
    yield put(createSmmPostChannelStatusSuccess(response));
  } catch (error) {
    yield put(createSmmPostChannelStatusFailure(error.message));
  }
}
//UPDATE_SMM_POST_CHANNEL_STATUS
function* updateSmmPostChannelStatusSaga(action) {
  try {
    const response = yield call(updateSmmPostChannelStatusApi, action.payload);
    yield put(updateSmmPostChannelStatusSuccess(response));
  } catch (error) {
    yield put(updateSmmPostChannelStatusFailure(error.message));
  }
}
//DELETE_SMM_POST_CHANNEL_STATUS
function* deleteSmmPostChannelStatusSaga(action) {
  try {
    const response = yield call(deleteSmmPostChannelStatusApi, action.payload);
    yield put(deleteSmmPostChannelStatusSuccess(response));
  } catch (error) {
    yield put(deleteSmmPostChannelStatusFailure(error.message));
  }
}
//FETCH_SMM_POST_LIST
function* fetchSmmPostListSaga() {
  try {
    const response = yield call(fetchSmmPostListApi);
    yield put(fetchSmmPostListSuccess(response));
  } catch (error) {
    yield put(fetchSmmPostListFailure(error.message));
  }
}
//FETCH_SMM_POST_DATA
function* fetchSmmPostDataSaga(action) {
  try {
    const response = yield call(fetchSmmPostDataApi, action.payload);
    yield put(fetchSmmPostDataSuccess(response));
  } catch (error) {
    yield put(fetchSmmPostDataFailure(error.message));
  }
}
//CREATE_SMM_POST
function* createSmmPostSaga(action) {
  try {
    const response = yield call(createSmmPostApi, action.payload);
    yield put(createSmmPostSuccess(response));
  } catch (error) {
    yield put(createSmmPostFailure(error.message));
  }
}
//UPDATE_SMM_POST
function* updateSmmPostSaga(action) {
  try {
    const response = yield call(updateSmmPostApi, action.payload);
    yield put(updateSmmPostSuccess(response));
  } catch (error) {
    yield put(updateSmmPostFailure(error.message));
  }
}
//DELETE_SMM_POST
function* deleteSmmPostSaga(action) {
  try {
    const response = yield call(deleteSmmPostApi, action.payload);
    yield put(deleteSmmPostSuccess(response));
  } catch (error) {
    yield put(deleteSmmPostFailure(error.message));
  }
}
//FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST
function* fetchMasterSocialMediaProviderListSaga() {
  try {
    const response = yield call(getListMasterSocialMediaProviderApi);
    yield put(fetchMasterSocialMediaProviderListSuccess(response));
  } catch (error) {
    yield put(fetchMasterSocialMediaProviderListFailure(error.message));
  }
}
//FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA
function* fetchMasterSocialMediaProviderDataSaga(action) {
  try {
    const response = yield call(
      getDataMasterSocialMediaProviderApi,
      action.payload
    );
    yield put(fetchMasterSocialMediaProviderDataSuccess(response));
  } catch (error) {
    yield put(fetchMasterSocialMediaProviderDataFailure(error.message));
  }
}
//CREATE_MASTER_SOCIAL_MEDIA_PROVIDER
function* createMasterSocialMediaProviderSaga(action) {
  try {
    const response = yield call(
      createMasterSocialMediaProviderApi,
      action.payload
    );
    yield put(createMasterSocialMediaProviderSuccess(response));
  } catch (error) {
    yield put(createMasterSocialMediaProviderFailure(error.message));
  }
}
//UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER
function* updateMasterSocialMediaProviderSaga(action) {
  try {
    const response = yield call(
      updateMasterSocialMediaProviderApi,
      action.payload
    );
    yield put(updateMasterSocialMediaProviderSuccess(response));
  } catch (error) {
    yield put(updateMasterSocialMediaProviderFailure(error.message));
  }
}
//DELETE_MASTER_SOCIAL_MEDIA_PROVIDER
function* deleteMasterSocialMediaProviderSaga(action) {
  try {
    const response = yield call(
      deleteMasterSocialMediaProviderApi,
      action.payload
    );
    yield put(deleteMasterSocialMediaProviderSuccess(response));
  } catch (error) {
    yield put(deleteMasterSocialMediaProviderFailure(error.message));
  }
}
//MASTER_SOCIAL_MEDIA_PROFILE_LIST
function* fetchMasterSocialMediaProfileListSaga() {
  try {
    const response = yield call(getListMasterSocialMediaProfileApi);
    yield put(fetchMasterSocialMediaProfileListSuccess(response));
  } catch (error) {
    yield put(fetchMasterSocialMediaProfileListFailure(error.message));
  }
}
//MASTER_SOCIAL_MEDIA_PROFILE_DATA
function* fetchMasterSocialMediaProfileDataSaga(action) {
  try {
    const response = yield call(
      getDataMasterSocialMediaProfileApi,
      action.payload
    );
    yield put(fetchMasterSocialMediaProfileDataSuccess(response));
  } catch (error) {
    yield put(fetchMasterSocialMediaProfileDataFailure(error.message));
  }
}
//CREATE_MASTER_SOCIAL_MEDIA_PROFILE
function* createMasterSocialMediaProfileSaga(action) {
  try {
    const response = yield call(
      createMasterSocialMediaProfileApi,
      action.payload
    );
    yield put(createMasterSocialMediaProfileSuccess(response));
  } catch (error) {
    yield put(createMasterSocialMediaProfileFailure(error.message));
  }
}
//UPDATE_MASTER_SOCIAL_MEDIA_PROFILE
function* updateMasterSocialMediaProfileSaga(action) {
  try {
    const response = yield call(
      updateMasterSocialMediaProfileApi,
      action.payload
    );
    yield put(updateMasterSocialMediaProfileSuccess(response));
  } catch (error) {
    yield put(updateMasterSocialMediaProfileFailure(error.message));
  }
}
//DELETE_MASTER_SOCIAL_MEDIA_PROFILE
function* deleteMasterSocialMediaProfileSaga(action) {
  try {
    const response = yield call(
      deleteMasterSocialMediaProfileApi,
      action.payload
    );
    yield put(deleteMasterSocialMediaProfileSuccess(response));
  } catch (error) {
    yield put(deleteMasterSocialMediaProfileFailure(error.message));
  }
}
// Watcher Sagas
function* watchFetchSmmPostChannelStatusList() {
  yield takeEvery(
    FETCH_SMM_POST_CHANNEL_STATUS_LIST,
    fetchSmmPostChannelStatusListSaga
  );
}

function* watchFetchSmmPostChannelStatusData() {
  yield takeEvery(
    FETCH_SMM_POST_CHANNEL_STATUS_DATA,
    fetchSmmPostChannelStatusDataSaga
  );
}

function* watchCreateSmmPostChannelStatus() {
  yield takeEvery(
    CREATE_SMM_POST_CHANNEL_STATUS,
    createSmmPostChannelStatusSaga
  );
}

function* watchUpdateSmmPostChannelStatus() {
  yield takeEvery(
    UPDATE_SMM_POST_CHANNEL_STATUS,
    updateSmmPostChannelStatusSaga
  );
}

function* watchDeleteSmmPostChannelStatus() {
  yield takeEvery(
    DELETE_SMM_POST_CHANNEL_STATUS,
    deleteSmmPostChannelStatusSaga
  );
}

function* watchFetchSmmPostList() {
  yield takeEvery(FETCH_SMM_POST_LIST, fetchSmmPostListSaga);
}

function* watchFetchSmmPostData() {
  yield takeEvery(FETCH_SMM_POST_DATA, fetchSmmPostDataSaga);
}

function* watchCreateSmmPost() {
  yield takeEvery(CREATE_SMM_POST, createSmmPostSaga);
}

function* watchUpdateSmmPost() {
  yield takeEvery(UPDATE_SMM_POST, updateSmmPostSaga);
}

function* watchDeleteSmmPost() {
  yield takeEvery(DELETE_SMM_POST, deleteSmmPostSaga);
}

function* watchFetchMasterSocialMediaProviderList() {
  yield takeEvery(
    FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_LIST,
    fetchMasterSocialMediaProviderListSaga
  );
}

function* watchFetchMasterSocialMediaProviderData() {
  yield takeEvery(
    FETCH_MASTER_SOCIAL_MEDIA_PROVIDER_DATA,
    fetchMasterSocialMediaProviderDataSaga
  );
}

function* watchCreateMasterSocialMediaProvider() {
  yield takeEvery(
    CREATE_MASTER_SOCIAL_MEDIA_PROVIDER,
    createMasterSocialMediaProviderSaga
  );
}

function* watchUpdateMasterSocialMediaProvider() {
  yield takeEvery(
    UPDATE_MASTER_SOCIAL_MEDIA_PROVIDER,
    updateMasterSocialMediaProviderSaga
  );
}

function* watchDeleteMasterSocialMediaProvider() {
  yield takeEvery(
    DELETE_MASTER_SOCIAL_MEDIA_PROVIDER,
    deleteMasterSocialMediaProviderSaga
  );
}

function* watchFetchMasterSocialMediaProfileList() {
  yield takeEvery(
    FETCH_MASTER_SOCIAL_MEDIA_PROFILE_LIST,
    fetchMasterSocialMediaProfileListSaga
  );
}

function* watchFetchMasterSocialMediaProfileData() {
  yield takeEvery(
    FETCH_MASTER_SOCIAL_MEDIA_PROFILE_DATA,
    fetchMasterSocialMediaProfileDataSaga
  );
}

function* watchCreateMasterSocialMediaProfile() {
  yield takeEvery(
    CREATE_MASTER_SOCIAL_MEDIA_PROFILE,
    createMasterSocialMediaProfileSaga
  );
}

function* watchUpdateMasterSocialMediaProfile() {
  yield takeEvery(
    UPDATE_MASTER_SOCIAL_MEDIA_PROFILE,
    updateMasterSocialMediaProfileSaga
  );
}

function* watchDeleteMasterSocialMediaProfile() {
  yield takeEvery(
    DELETE_MASTER_SOCIAL_MEDIA_PROFILE,
    deleteMasterSocialMediaProfileSaga
  );
}

// ---------------------------------------------- Task 24873, connect ---
// Every one of these follows the house shape: call, put success, put failure
// on throw. The failure payload is the error itself so the screen can show
// what the platform actually said rather than "something went wrong".
function* socialMediaConnectStartSaga(action) {
  try {
    const response = yield call(socialMediaConnectStartApi, action.payload);
    yield put(socialMediaConnectStartSuccess(response));
  } catch (error) {
    yield put(socialMediaConnectStartFailure(error));
  }
}

function* socialMediaConnectCompleteSaga(action) {
  try {
    const response = yield call(socialMediaConnectCompleteApi, action.payload);
    yield put(socialMediaConnectCompleteSuccess(response));
  } catch (error) {
    yield put(socialMediaConnectCompleteFailure(error));
  }
}

function* socialMediaConnectAssignSaga(action) {
  try {
    const response = yield call(socialMediaConnectAssignApi, action.payload);
    yield put(socialMediaConnectAssignSuccess(response));
  } catch (error) {
    yield put(socialMediaConnectAssignFailure(error));
  }
}

function* socialMediaConnectDisconnectSaga(action) {
  try {
    const response = yield call(socialMediaConnectDisconnectApi, action.payload);
    yield put(socialMediaConnectDisconnectSuccess(response));
  } catch (error) {
    yield put(socialMediaConnectDisconnectFailure(error));
  }
}

function* watchSocialMediaConnectStart() {
  yield takeEvery(SOCIAL_MEDIA_CONNECT_START, socialMediaConnectStartSaga);
}
function* watchSocialMediaConnectComplete() {
  yield takeEvery(SOCIAL_MEDIA_CONNECT_COMPLETE, socialMediaConnectCompleteSaga);
}
function* watchSocialMediaConnectAssign() {
  yield takeEvery(SOCIAL_MEDIA_CONNECT_ASSIGN, socialMediaConnectAssignSaga);
}
function* watchSocialMediaConnectDisconnect() {
  yield takeEvery(
    SOCIAL_MEDIA_CONNECT_DISCONNECT,
    socialMediaConnectDisconnectSaga
  );
}

// Generate SMM Post Content
function* generateSmmPostContentSaga(action) {
  try {
    const response = yield call(generateSmmPostContentApi, action.payload);
    yield put(generateSmmPostContentSuccess(response));
  } catch (error) {
    yield put(generateSmmPostContentFailure(error.message));
  }
}

function* watchGenerateSmmPostContent() {
  yield takeEvery(GENERATE_SMM_POST_CONTENT, generateSmmPostContentSaga);
}

//GENERATE_SMM_POST_IMAGE
function* generateSmmPostImageSaga(action) {
  try {
    const response = yield call(generateSmmPostImageApi, action.payload);
    yield put(generateSmmPostImageSuccess(response));
  } catch (error) {
    yield put(generateSmmPostImageFailure(error.message));
  }
}

function* watchGenerateSmmPostImage() {
  yield takeEvery(GENERATE_SMM_POST_IMAGE, generateSmmPostImageSaga);
}

// Root Saga
export default function* socialMediaManagementSaga() {
  yield all([
    watchFetchSmmPostChannelStatusList(),
    watchFetchSmmPostChannelStatusData(),
    watchCreateSmmPostChannelStatus(),
    watchUpdateSmmPostChannelStatus(),
    watchDeleteSmmPostChannelStatus(),
    watchFetchSmmPostList(),
    watchFetchSmmPostData(),
    watchCreateSmmPost(),
    watchUpdateSmmPost(),
    watchDeleteSmmPost(),
    watchFetchMasterSocialMediaProviderList(),
    watchFetchMasterSocialMediaProviderData(),
    watchCreateMasterSocialMediaProvider(),
    watchUpdateMasterSocialMediaProvider(),
    watchDeleteMasterSocialMediaProvider(),
    watchFetchMasterSocialMediaProfileList(),
    watchFetchMasterSocialMediaProfileData(),
    watchCreateMasterSocialMediaProfile(),
    watchUpdateMasterSocialMediaProfile(),
    watchDeleteMasterSocialMediaProfile(),
    watchGenerateSmmPostContent(),
    watchGenerateSmmPostImage(),
    watchSocialMediaConnectStart(),
    watchSocialMediaConnectComplete(),
    watchSocialMediaConnectAssign(),
    watchSocialMediaConnectDisconnect(),
  ]);
}
